class Field {
  constructor(name, value) {
    this.name = name;
    this.value = value;
  }
}

export { Field };
